"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardAPI = void 0;
var api_client_1 = __importDefault(require("../api-client"));
var DashboardAPI = /** @class */ (function () {
    function DashboardAPI() {
    }
    DashboardAPI.fetchTopTraders = function (payload) {
        return api_client_1.default.post('/v2/dashboard/get-top-traders', payload);
    };
    DashboardAPI.fetchTopCollections = function (payload) {
        return api_client_1.default.post('/v2/dashboard/get-top-collections', payload);
    };
    DashboardAPI.fetchLatestArtistsNfts = function (payload) {
        return api_client_1.default.post('/v2/dashboard/get-latest-nfts-for-artists', payload);
    };
    return DashboardAPI;
}());
exports.DashboardAPI = DashboardAPI;
